export function FilterBar({ children, onReset, resetLabel, search }) {
  return (
    <div className="filter-bar">
      {search ? <div className="filter-search">{search}</div> : null}
      <div className="filter-controls">{children}</div>
      {onReset ? (
        <button type="button" className="btn btn-ghost" onClick={onReset}>
          {resetLabel}
        </button>
      ) : null}
    </div>
  );
}
